import { ethers } from 'ethers';
import { ACTIVE_NETWORK } from '../config/networks';
import { CONTRACTS } from '../config/contracts';
import ADNFTV2_ABI from '../config/abi/ADNFTV2.json';
import ERC20_ABI from '../config/abi/ERC20.json';

export function getADNFTContract(signerOrProvider) {
  return new ethers.Contract(CONTRACTS[ACTIVE_NETWORK].ADNFTV2, ADNFTV2_ABI, signerOrProvider);
}

export function getUSDTContract(signerOrProvider) {
  return new ethers.Contract(CONTRACTS[ACTIVE_NETWORK].USDT, ERC20_ABI, signerOrProvider);
}

export function getADNFTAddress() { return CONTRACTS[ACTIVE_NETWORK].ADNFTV2; }
export function getUSDTAddress()  { return CONTRACTS[ACTIVE_NETWORK].USDT; }
